// extracted by mini-css-extract-plugin
export default {"header":"Header-module--header--aLpZa","narrow":"Header-module--narrow--6nTPZ"};